// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2611":"c3a71a48","6950":"821ce74f","7171":"821ce74f"}[chunkId] + ".chunk.css";
};